// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"el_a bha_a bha_x bha_j bha_u bha_bc bha_pp bha_up"};